import { render, staticRenderFns } from "./PaymentsForRep.vue?vue&type=template&id=7318f48d&"
import script from "./PaymentsForRep.vue?vue&type=script&lang=js&"
export * from "./PaymentsForRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports